import { HttpStatusCode } from "axios";
import { z } from "zod";

export const UpdateVehicleRequestSchema = z.object({
	nickName: z.string().optional(),
	preferredVehicle: z.enum(["Y", "N"]).optional(),
	vehicleId: z.string(),
});

/**
 * Currently unused as of 03/24/2025
 */
export const UpdateVehicleResponseSchema = z.object({
	statusCode: z.literal(HttpStatusCode.Ok),
	body: z.object({
		data: z.object({
			make: z.enum(["L", "T"]),
			model: z.string().optional(),
			modelYear: z.string().optional(),
			/**
			 * If nickname did not exist prior and empty string is passed as nick name then no nickname is returned.
			 * If nickname existed prior and and empty string is passed as nick name then returned nickname is empty string.
			 */
			nickName: z
				.string()
				.optional()
				.transform((x) => (!x ? undefined : x)),
			preferredVehicle: z.enum(["Y", "N"]),
			vehicleId: z.string(),
			vin: z.string().optional(),
		}),
	}),
});
